/**
 * Ryan O'Dowd
 * 2022-05-20
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, size}) => {
  return {
    container: {
      display: 'flex',
      flexShrink: 1,
      flexGrow: 0,
    },
    inner: {
      width: globalScale * size,
      borderRadius: globalScale * Math.ceil(size / 2),
      backgroundColor: colors.primary,
    },
    streakText: {
      color: colors.primaryDark,
      fontSize: globalScale * (size / 5), // @TODO: is this reasonable for other scales/device sizes?
      margin: globalScale * 4,
      alignSelf: 'center',
      textAlign: 'center',
      fontFamily: fonts.secondaryBold,
    },
    streakActive: {
      color: colors.accent,
    },
    dailyGoalRings: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    label: {
      color: colors.gray,
      marginVertical: 0, // @NOTE: to offset Popover.Text
    },
  };
};

export default getStyles;
